import type { TenantSsoProviderDTO } from '../tenantSsoProvider.types';
import dayjs from 'dayjs';
import i18next from 'i18next';

export class TenantSsoProviderModel {
  private readonly _dto: TenantSsoProviderDTO;

  constructor(dto: TenantSsoProviderDTO) {
    this._dto = dto;
  }

  get originDTO(): TenantSsoProviderDTO {
    return this._dto;
  }

  get id(): string {
    return this._dto.id;
  }

  get tenantId(): string {
    return this._dto.tenantId;
  }

  get registrationId(): string {
    return this._dto.registrationId;
  }

  get providerName(): string {
    return this._dto.providerName;
  }

  get issuerUri(): string {
    return this._dto.issuerUri;
  }

  get clientId(): string {
    return this._dto.clientId;
  }

  get redirectUri(): string {
    return this._dto.redirectUri ?? '';
  }

  get scopes(): string {
    return this._dto.scopes ?? 'openid,profile,email';
  }

  get userNameAttribute(): string {
    return this._dto.userNameAttribute ?? 'email';
  }

  get userInfoUri(): string {
    return this._dto.userInfoUri ?? '';
  }

  get enabled(): boolean {
    return this._dto.enabled;
  }

  get createdDate(): string {
    return this._dto.createdDate ? dayjs(this._dto.createdDate).format('YYYY.MM.DD HH:mm') : '';
  }

  get updatedDate(): string {
    return this._dto.updatedDate ? dayjs(this._dto.updatedDate).format('YYYY.MM.DD HH:mm') : '';
  }

  get statusLabel(): string {
    if (this.enabled) {
      return i18next.t('SsoProvider.Status.Active', { defaultValue: '활성' });
    }
    return i18next.t('SsoProvider.Status.Inactive', { defaultValue: '비활성' });
  }

  get statusColor(): 'green' | 'red' {
    return this.enabled ? 'green' : 'red';
  }
}
